import { render, staticRenderFns } from "./MesaObrasVisadoPrevioConsultas.vue?vue&type=template&id=1c830a64&"
import script from "./MesaObrasVisadoPrevioConsultas.vue?vue&type=script&lang=js&"
export * from "./MesaObrasVisadoPrevioConsultas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports